let configurazione = {
    urlBackend: "http://localhost:8080/relazioni-parametrizzate/rest/",
    urlApplicativo: "http://localhost:3000/",
    token: "",
    deployContext: "SVILUPPO",
    pathRadice: "relazioneStatoAmbiente",
    tipoAmbiente: "FO"
}
export default configurazione;